export enum OfferStatusEnum {
  Active = "Active",
  Blocked = "Blocked",
  Expired = "Expired",
  ComingSoon = "ComingSoon",

}
